import React from "react";
import {
  Form,
  Divider,
  PageHeader
} from "antd";

class Index extends React.Component {
  constructor(props) {
    var user = JSON.parse(localStorage.getItem("user"));
    super(props);
    this.state = {
      usuario: user.userName,
      nombre: user.nombre,
      apellidoPaterno: user.apellidoPaterno,
      apellidoMaterno: user.apellidoMaterno,
      correo: user.correo,
    };
  }

  item = (label, value) => {
    return (
      <div
        style={{
          width: "100%",
          display: "inline-flex",
          marginBottom: 8,
          background: "#fafafa",
        }}
      >
        <div style={{ width: "170px", color: "#242424", padding: 6 }}>
          {label}
        </div>
        <div style={{ width: "calc(100% - 170px)", padding: 6 }}>{value}</div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <PageHeader title="Mi Perfil" />
        <Divider />
        <Form>
          <div className="row">
            <div className="col-md-12 form-group">
              {this.item("Usuario:", this.state.usuario)}
              {this.item("Nombre:", this.state.nombre)}
              {this.item("Apellido Paterno:", this.state.apellidoPaterno)}
              {this.item("Apellido Materno:", this.state.apellidoMaterno)}
              {this.item("Correo:", this.state.correo)}
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default Form.create()(Index);
